import { atom, selector } from "recoil";
import { pageState } from "../../../state/GlobalState";
import { permissionState } from "../../../api/state/AuthState";
import moment from "moment";

export const vesselPermitReportListState = atom({
    key: 'vesselPermitReportListState',
    default: [],
})

export const vesselPermitReportCustomerState = atom({
    key: 'vesselPermitReportCustomerState',
    default: {
        data: [],
        ovf: false,
    }
})

export const vesselPermitReportVesselState = atom({
    key: 'vesselPermitReportVesselState',
    default: {
        data: [],
        ovf: false,
    }
})

export const vesselPermitReportFromDateState = atom({
    key: 'vesselPermitReportFromDateState',
    default: moment().subtract(1, 'month').format('YYYY-MM-DD'),
})

export const vesselPermitReportToDateState = atom({
    key: 'vesselPermitReportToDateState',
    default: moment().format('YYYY-MM-DD'),
})

export const vesselPermitReportCustomerValueState = atom({
    key: 'vesselPermitReportCustomerValueState',
    default: { label: "All", value: 0 },
})

export const vesselPermitReportVesselValueState = atom({
    key: 'vesselPermitReportVesselValueState',
    default: { label: "All", value: 0 },
})

export const modalConfigDefault = { size: "lg", wizard: false }

export const vesselPermitReportFilterState = selector({
    key: 'vesselPermitReportFilterState',
    get: ({ get }) => ([
        {
            label: 'From Date',
            size: 6,
            offset: 0,
            required: true,
            type: 'datepicker',
            value: get(vesselPermitReportFromDateState),
        },
        {
            label: 'To Date',
            size: 6,
            offset: 0,
            required: true,
            type: 'datepicker',
            value: get(vesselPermitReportToDateState),
        },
        {
            label: 'Customer',
            size: 6,
            offset: 0,
            required: false,
            type: 'select',
            value: get(vesselPermitReportCustomerValueState),
            list: get(vesselPermitReportCustomerState),
        },
        {
            label: 'Vessel',
            size: 6,
            offset: 0,
            required: false,
            type: 'select',
            value: get(vesselPermitReportVesselValueState),
            list: get(vesselPermitReportVesselState),
        },
    ]),
    set: ({ set }, e) => {
        if(e.filterLabel === 'From Date'){
            set(vesselPermitReportFromDateState, e.value)
        }
        if(e.filterLabel === 'To Date'){
            set(vesselPermitReportToDateState, e.value)
        }
        if(e.filterLabel === 'Customer'){
            set(vesselPermitReportCustomerValueState, e.value)
        }
        if(e.filterLabel === 'Vessel'){
            set(vesselPermitReportVesselValueState, e.value)
        }
    }
})

export const formModes = {
    view: [ { name: 'Default View' } ],
}

export const vesselPermitReportDataStructureState = selector({
    key: 'vesselPermitReportDataStructureState',
    get: ({ get }) => (
        [
            { 
                label: 'Customer',
                field: 'customer_name',
                type: 'text',
                order: { table: 1, form: 1 }, 
                create: [{ enabled: false }], update: ['same_as:create.0'], view: [{ enabled: true, size: 12 }], 
            },
            { 
                label: 'Vessel',
                field: 'vessel_name',
                type: 'text',
                order: { table: 2, form: 2 }, 
                create: [{ enabled: false }], update: ['same_as:create.0'], view: [{ enabled: true, size: 12 }], 
            },
            {
                label: 'Registration Number',
                field: 'registration_number',
                type: 'text',
                order: { table: 2.5, form: 2.5 },
                create: [{ enabled: false }], update: ['same_as:create.0'], view: [{ enabled: true, size: 12 }],
                tableDefault: '-',
            },
            { 
                label: 'Permit Type',
                field: 'permit_type_name',
                type: 'text',
                order: { table: 3, form: 3 }, 
                create: [{ enabled: false }], update: ['same_as:create.0'], view: [{ enabled: true, size: 12 }], 
            },
            {
                label: 'Permit Taken',
                field: 'created_at',
                type: 'text',
                order: { table: 3.5, form: 3.5 },
                create: [{ enabled: false }], update: ['same_as:create.0'], view: [{ enabled: true, size: 12 }],
                tableDefault: '-',
            },
            { 
                label: 'Effective (local)',
                field: 'effective_at',
                type: 'datetime',
                order: { table: 4, form: 4 }, 
                create: [{ enabled: false }], update: ['same_as:create.0'], view: [{ enabled: true, size: 12 }], 
            },
            { 
                label: 'Expires (local)',
                field: 'expires_at',
                type: 'datetime',
                order: { table: 5, form: 5 }, 
                create: [{ enabled: false }], update: ['same_as:create.0'], view: [{ enabled: true, size: 12 }], 
            },
        ].filter((v)=>{
            const page = get(pageState)
            const permissions = get(permissionState)
            if(! v.permission){
                return true
            }
            let absolute = false;
            if(v.permission.substr(0,1) === ":"){
                absolute = true;
                v.permission = v.permission.substr(1)
            }
            v.permission = absolute ? v.permission : v.permission + "-" + page
            return permissions?.includes(v.permission)
        })
    )
}) 